import { useParams } from "react-router-dom";

export const EansHamburg = () => {
  const { id } = useParams();
  const path = '/newsletter/versions/eans_hamburg.html';
  return (
    <iframe
      title={"EANS Hamburg"}
      src={path}
      style={{ width: "100vw", height: "100vh" }}
    />
  );
};
